import { postWithAuth, getWithAuth } from '../../Basic/HttpService';
import moment from 'moment';
import _ from 'lodash';

const downloadFileWithExt = async (res, fileExt, fileName = 'Report') => {
    if (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.getElementById('tempDownloadPDFLink') || document.createElement('a');
        link.id = 'tempDownloadPDFLink';
        link.href = url;
        link.setAttribute('download', `${fileName}${moment().format('DD-MMM-YYYY HH:mm')}.${fileExt}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        return true;
    }
};

export const GetVORReportingExcelFile = async (params) => {
    const query = [];

    if (params.active) query.push(`active=${params.active}`);
    if (params.VehicleID) query.push(`VehicleID=${params.VehicleID}`);
    if (params.fromDate) query.push(`startDate=${params.fromDate}`);
    if (params.toDate) query.push(`endDate=${params.toDate}`);
    if (params.customerID) query.push(`Id=${params.customerID}`);
    if (params.vehicleCategoryID) query.push(`vehicleCategoryID=${params.vehicleCategoryID}`);
    if (params.makeID) query.push(`makeID=${params.makeID}`);

    let sortedQ = query.length ? `?${query.join('&')}` : '';

    let res = await getWithAuth(`VORVehicles/GetExcelFile${sortedQ}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt, 'VOR');
};
export const GetDefectReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleDefects/GetDefectExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt);
};
export const GetBreakdownReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleBreakdowns/GetBreakdownExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt);
};
export const GetJobReportingExcelFile = async (params) => {
    let res = await getWithAuth(`VehicleJob/GetJobExcelFile?startDate=${params.fromDate}&endDate=${params.toDate}&Id=${params.customerID}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt);
};

export const GetSchedulesExcelFile = async (params) => {
    let res = await getWithAuth(
        `Schedules/DownLoadExcelFile?status=${params.status}
    &mode=${params.mode}
    &startDate=${params.startDate}
    &endDate=${params.endDate}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt);
};

export const GetVORExcelFile = async (params) => {
    let res = await getWithAuth(
        `VORVehicles?active=${params.active}&VehicleID=${params.VehicleID}&StartDate=${params.StartDate}&EndDate=${params.EndDate}&CustomerId=${params.CustomerId}&Make=${params.Make}&Model=${params.Model}`,
        {
            responseType: 'blob',
            returnOrgRes: true
        }
    );
    downloadFileWithExt(res, params.fileExt, 'VOR-Report');
};

export const GetOutstandingDocSchedulesExcelFile = async (params) => {
    let temp = '';

    if (!_.isEmpty(params.filterValues)) {
        for (const property in params.filterValues) {
            temp = temp + `&${property}=${params.filterValues[property]}`;
        }
    }
    let res = await getWithAuth(`Schedules/OutstandingScheduleDoc/DownLoadExcelFile?received=${params.received}${temp}`, {
        responseType: 'blob',
        returnOrgRes: true
    });
    downloadFileWithExt(res, params.fileExt);
};
